<nb-card class="helix-popup-body">
  <nb-card-header>
    <div class="header-container">Upload Asset Document</div>
  </nb-card-header>
  <nb-card-body>
    <p-fileUpload
      #fileUpload
      name="file"
      url="{{ documentCreateUrl }}"
      (onBeforeUpload)="onBeforeUpload($event)"
      (onSend)="onSend()"
      (onUpload)="onUpload()"
      (onError)="onError()"
      [auto]="false"
      [fileLimit]="1"
      [multiple]="false"
      [showUploadButton]="false"
    >
    </p-fileUpload>
    <form
      [formGroup]="assetDocumentUploadForm"
      (ngSubmit)="onSubmit()"
      class="form-container"
    >
      <div class="input-container">
        <input
          nbInput
          fullWidth
          formControlName="caption"
          type="text"
          placeholder="Enter Caption for File"
        />
      </div>
      <div class="button-container">
        <button
          type="submit"
          nbButton
          status="primary"
          class="btn-primary btn-outline btn-small"
        >
          Upload Document
        </button>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      status="primary"
      class="btn-primary btn-outline btn-small"
      (click)="close()"
    >
      Close
    </button>
  </nb-card-footer>
</nb-card>
